import * as types from './mutation_types'
// import Cookies from '/src/utils/cookies'
// import Vue from 'vue'

const state = {
  phone: '',
}

const getters = {
  phone: state => state.phone,
}

const mutations = {
  [types.SET_PHONE_BEFORE_SIGNIN] (state, data) {
    state.phone = data.phone
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
}
